import { render } from "./index.vue?vue&type=template&id=6dba25a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6dba25a7"

export default script